import $ from 'jquery'
import InfiniteScroll from 'infinite-scroll'
import mediumZoom from 'medium-zoom'

const inf = $('.infinity-posts')
if (inf.length) {
  new InfiniteScroll(inf[0], {
    path: '.nav-previous a',
    append: '.infinity-post',
    history: 'push',
    /*status: '.page-loading-status',*/
  })
}

mediumZoom('.wp-block-image > img', {
  scrollOffset: 0,
})
